// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.VerifyLandlordIdentityExtendedWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { VerifyLandlordIdentityExtendedWebApiHandler_verifyLandlordIdentityExtended } from '@zg-rentals/ts-rent-payment-client';

import type {
  VerifyLandlordIdentityExtendedWebApiRequestDto,
  VerifyLandlordIdentityExtendedWebApiResponseDto,
} from '@zg-rentals/ts-rent-payment-client';

export interface VerifyLandlordIdentityExtendedWebApiHandler_verifyLandlordIdentityExtended_Args {
  postData: VerifyLandlordIdentityExtendedWebApiRequestDto;
}

export type VerifyLandlordIdentityExtendedWebApiHandler_verifyLandlordIdentityExtended_Options = UseMutationOptions<
  VerifyLandlordIdentityExtendedWebApiResponseDto,
  unknown,
  VerifyLandlordIdentityExtendedWebApiHandler_verifyLandlordIdentityExtended_Args
>;

/**
 * Verify landlord identity extended
 */
export const useVerifyLandlordIdentityExtendedWebApiHandler_verifyLandlordIdentityExtended = ({
  httpClient,
  ...options
}: Omit<VerifyLandlordIdentityExtendedWebApiHandler_verifyLandlordIdentityExtended_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: VerifyLandlordIdentityExtendedWebApiHandler_verifyLandlordIdentityExtended_Args) =>
      VerifyLandlordIdentityExtendedWebApiHandler_verifyLandlordIdentityExtended(args.postData, httpClient),
  });
};
